var map = {
	"./bagel-de-pina.jpg": "2354",
	"./hamburguesa-de-res.jpg": "3f22",
	"./new-york.jpg": "f0fe",
	"./picana.jpg": "5388",
	"./tenders-veganos.jpg": "efc0",
	"./tortas-de-porkbelly.jpg": "31da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7ab";